var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { ImxPendingBurnStatus } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useState } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
export function useClaimTokens() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var user = useContext(UserContext).user;
    var _a = useState(false), showSuccess = _a[0], setShowSuccess = _a[1];
    function showConfirmDialog() {
        var _a, _b, _c;
        setDialogProps({
            common: {
                title: t('claim-token.page-title'),
                actions: [{ highlighted: true, text: t('common.confirm'), action: claim }],
                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
            },
            custom: {
                type: DialogType.CLAIM_TOKEN,
                ctaTokenValue: ((_a = user === null || user === void 0 ? void 0 : user.ctaTokenClaimable) === null || _a === void 0 ? void 0 : _a.amountFormated) || '',
                wallet: "CTA Wallet (".concat((_b = user === null || user === void 0 ? void 0 : user.mpcWalletAddress) === null || _b === void 0 ? void 0 : _b.slice(0, 5), "...").concat((_c = user === null || user === void 0 ? void 0 : user.mpcWalletAddress) === null || _c === void 0 ? void 0 : _c.slice(-4), ")"),
            },
        });
    }
    function claim() {
        return __awaiter(this, void 0, void 0, function () {
            var result, pendingTransferUuid, completed, pendingTransfer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(user === null || user === void 0 ? void 0 : user.ctaTokenClaimable) || user.ctaTokenClaimable.claimed === true)
                            return [2 /*return*/];
                        setServerLoading(true);
                        return [4 /*yield*/, gqlSdk.CtaTokenClaim()];
                    case 1:
                        result = _a.sent();
                        pendingTransferUuid = result.ctaTokenClaim.uuid;
                        completed = false;
                        _a.label = 2;
                    case 2:
                        if (!(completed === false)) return [3 /*break*/, 6];
                        return [4 /*yield*/, gqlSdk.BlockchainPendingCtaTtokenTransferFindOne({
                                input: { pendingCtaTokenTransferUuid: pendingTransferUuid },
                            })];
                    case 3:
                        pendingTransfer = _a.sent();
                        completed = pendingTransfer.blockchainPendingCtaTtokenTransferFindOne.status === ImxPendingBurnStatus.COMPLETED;
                        if (!!completed) return [3 /*break*/, 5];
                        return [4 /*yield*/, sleep(2000)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 2];
                    case 6:
                        setDialogProps(undefined);
                        setServerLoading(false);
                        setShowSuccess(true);
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        claim: claim,
        showConfirmDialog: showConfirmDialog,
        showSuccess: showSuccess,
    };
}
